<div class="grid-container padding-y-4">
    <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-bottom-2">
            <legend class="usa-legend usa-legend--large" *ngIf="initiateSurveyComponents">Please complete to initiate an electronic GSA Form 3080</legend>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
            <legend class="usa-legend usa-legend--medium">{{headerMsg}}</legend>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            {{this.surveyNo ? 'Survey No: ' + this.surveyNo : ''}}
        </div>
    </div>

    <div class="grid-row" *ngIf="(!showAmcForm && !showCarrierForm) || (showAmcForm) || (showCarrierForm)">
        <div class="usa-alert usa-alert--info usa-alert--slim usa-alert--no-icon">
            <div class="usa-alert__body">
                <p class="usa-alert__text" *ngIf="(!showAmcForm && !showCarrierForm)">
                    Please review the details and complete the survey
                </p>
                <p class="usa-alert__text" *ngIf="showAmcForm">
                    Please review the details and click 'Submit Request' for any additional changes
                </p>
                <p class="usa-alert__text" *ngIf="showCarrierForm">
                    Please review the details and the responses
                </p>
            </div>
        </div>
    </div>
    <form [formGroup]="evaluationForm">
        <div class="grid-row grid-gap-1 padding-top-4">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <h5><strong>Transferee Details</strong></h5>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <label for="employee_first_name" class="usa-label">First Name <abbr title="required"
                        class="usa-hint usa-hint--required">*</abbr></label>
                <input type="text" id="employee_first_name" class="maxw-full usa-input" formControlName="employeeFname" [maxlength]="35" [readonly]='isReadOnly'>
                <div class="define-text-secondary " *ngIf="isFormControlInValid('employeeFname')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>First name is required
                </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <div class="grid-row">
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                        <label for="employee_middle_initial" class="usa-label">M.I</label>
                        <input type="text" id="employee_middle_initial" class="maxw-full usa-input" formControlName="employeeMi" [maxlength]="1" [readonly]='isReadOnly'>
                    </div>
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
                        <label for="employee_last_name" class="usa-label">Last Name
                            <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
                        </label>
                        <input type="text" id="employee_last_name" class="maxw-full usa-input" formControlName="employeeLname" [maxlength]="35" [readonly]='isReadOnly'>
                        <div class="define-text-secondary " *ngIf="isFormControlInValid('employeeLname')">
                            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                            </svg>Last name is required
                        </div>
                    </div>
                </div>
            </div>

            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <div class="grid-row">
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
                        <label for="employee_Telephone" class="usa-label">Telephone
                            <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
                        </label>
                        <input type="text" id="employee_Telephone" class="maxw-full usa-input" formControlName="employeePhone" [maxlength]="20" appNumbersOnly [readonly]='isReadOnly'>
                        <div class="define-text-secondary" *ngIf="isFormControlInValid('employeePhone')">
                            <div *ngIf="evaluationForm.get('employeePhone').hasError('minlength')">
                                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                </svg> Telephone must be 10 digits
                            </div>
                            <div class="define-text-secondary" *ngIf="evaluationForm.get('employeePhone').hasError('required')">
                                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                </svg> Telephone is required
                            </div>
                        </div>
                    </div>
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                        <label for="employee_telephone_ext" class="usa-label">Extension</label>
                        <input type="text" id="employee_telephone_ext" class="maxw-full usa-input" formControlName="employeePhoneExt" [maxlength]="5" appNumbersOnly [readonly]='isReadOnly'>
                    </div>
                </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <label for="employee_email" class="usa-label">Email
                    <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
                </label>
                <input type="text" id="employee_email" class="maxw-full usa-input" formControlName="employeeEmail" [maxlength]="254" [readonly]='isReadOnly'>
                <div *ngIf="isFormControlInValid('employeeEmail')">
                    <div class="define-text-secondary" *ngIf="evaluationForm.get('employeeEmail').hasError('email')">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                        </svg> Enter a valid email
                    </div>
                    <div class="define-text-secondary" *ngIf="evaluationForm.get('employeeEmail').hasError('required')">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                        </svg> Email is required
                    </div>
                </div>
            </div>
        </div>
      <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label class="usa-label" for="customer_name_new">Transferee's Agency Name (optional)</label>
          <ng-template #agencySearchTemplate let-model="item" let-index="index">
            {{model.agencyBureauName}} - {{model.agencyCode}}
          </ng-template>
          <input id="customer_name_new" class="usa-input maxw-full"
                 [attr.disabled]="isReadOnly || showAmcForm || null"
                 formControlName='agency' placeholder="Select agency"
                 [typeaheadOptionsInScrollableView]="10" [typeaheadOptionsLimit]="300" [typeaheadMinLength]="0" (typeaheadOnSelect)="changeAgency($event)" typeaheadOptionField="agencyBureauName"
                 [typeahead]="agencyMaster" [typeaheadItemTemplate]="agencySearchTemplate" [typeaheadScrollable]="true">
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf="!isReadOnly && !showAmcForm; else readOnlyBureau">
          <label for="bureau_name_new" class="usa-label">Transferee's Bureau Name (optional)</label>
          <select id="bureau_name_new" class="usa-select maxw-full" formControlName="bureauCode" name="bureauCode">
            <option value='null' selected disabled>Choose...</option>
            <option *ngFor='let b of bureauMaster' [value]="b.bureauCode">{{b.agencyBureauName}}
              - {{b.bureauCode}} </option>
          </select>
        </div>
        <ng-template #readOnlyBureau>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="bureau_name_new" class="usa-label">Transferee's Bureau Name (optional)</label>
            <input type="text" id="bureau_name_value" class="maxw-full usa-input" formControlName="bureauCode" [readonly]='true'>
          </div>
        </ng-template>
      </div>


        <div class="grid-row grid-gap-1 padding-top-4">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <h5><strong>Agency Move Coordinator contact who initiated this move</strong></h5>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <label for="officer_first_name" class="usa-label">First Name
                    <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
                </label>
                <input type="text" id="officer_first_name" class="maxw-full usa-input" formControlName="amcFname" [maxlength]="35" [readonly]='isReadOnly'>
                <div class="define-text-secondary " *ngIf="isFormControlInValid('amcFname')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>First name is required
                </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <div class="grid-row">
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                        <label for="officer_middle_initial" class="usa-label">M.I</label>
                        <input type="text" id="officer_middle_initial" class="maxw-full usa-input" formControlName="amcMi" [maxlength]="1" [readonly]='isReadOnly'>
                    </div>
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
                        <label for="officer_last_name" class="usa-label">Last Name
                            <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
                        </label>
                        <input type="text" id="officer_last_name" class="maxw-full usa-input" formControlName="amcLname" [maxlength]="35" [readonly]='isReadOnly'>
                        <div class="define-text-secondary" *ngIf="isFormControlInValid('amcLname')">
                            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                            </svg>Last name is required
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <div class="grid-row">
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
                        <label for="officer_telephone" class="usa-label">Telephone
                            <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
                        </label>
                        <input type="text" id="officer_telephone" class="maxw-full usa-input" formControlName="amcPhone" [maxlength]="20" appNumbersOnly [readonly]='isReadOnly'>
                        <div *ngIf="isFormControlInValid('amcPhone')" class="define-text-secondary">
                            <div *ngIf="evaluationForm.get('amcPhone').hasError('minlength')">

                                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                </svg>Telephone must be 10 digits

                            </div>
                            <div *ngIf="evaluationForm.get('amcPhone').hasError('required')">

                                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                </svg>Telephone is required

                            </div>
                        </div>
                    </div>
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                        <label class="usa-label" for="officer_telephone_ext">Extension</label>
                        <input type="text" id="officer_telephone_ext" class="maxw-full usa-input" formControlName="amcPhoneExt" [maxlength]="5" appNumbersOnly [readonly]='isReadOnly'>
                    </div>
                </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <label for="officer_email" class="usa-label">Email
                    <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
                </label>
                <input type="text" id="officer_email" class="maxw-full usa-input" formControlName="amcEmail" [maxlength]="254" [readonly]='isReadOnly'>
                <div *ngIf="isFormControlInValid('amcEmail')" class="define-text-secondary">
                    <div *ngIf="evaluationForm.get('amcEmail').hasError('email')">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                        </svg> Enter a valid email
                    </div>
                    <div *ngIf="evaluationForm.get('amcEmail').hasError('required')">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                        </svg> Email is required
                    </div>
                </div>
            </div>
        </div>

        <div class="grid-row grid-gap-1 padding-top-4">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <h5><strong>TSP contact initiating this survey</strong></h5>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <label for="carrier_contact_first_name" class="usa-label">First Name
                    <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
                </label>
                <input type="text" id="carrier_contact_first_name" class="maxw-full usa-input" [maxlength]="35" [readonly]='isReadOnly' formControlName="tspContactFname">
                <div class="define-text-secondary" *ngIf="isFormControlInValid('tspContactFname')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>First name is required
                </div>
            </div>

            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <div class="grid-row">
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                        <label for="carrier_contact_middle_initial" class="usa-label">M.I</label>
                        <input type="text" id="carrier_contact_middle_initial" class="maxw-full usa-input" [maxlength]="1" [readonly]='isReadOnly' formControlName="tspContactMi">
                    </div>
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
                        <label for="carrier_contact_last_name" class="usa-label">Last Name
                            <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
                        </label>
                        <input type="text" id="carrier_contact_last_name" class="maxw-full usa-input" [maxlength]="35" [readonly]='isReadOnly' formControlName="tspContactLname">
                        <div class="define-text-secondary" *ngIf="isFormControlInValid('tspContactLname')">
                            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                            </svg>Last name is required
                        </div>
                    </div>
                </div>
            </div>

            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <div class="grid-row">
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
                        <label for="carrier_contact_telephone" class="usa-label">Telephone
                            <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
                        </label>
                        <input type="text" id="carrier_contact_telephone" class="usa-input maxw-full" [maxlength]="20" appNumbersOnly [readonly]='isReadOnly' formControlName="tspContactPhone">
                        <div *ngIf="isFormControlInValid('tspContactPhone')" class="define-text-secondary">
                            <div *ngIf="evaluationForm.get('tspContactPhone').hasError('minlength')">
                                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                </svg> Telephone must be 10 digits
                            </div>
                            <div *ngIf="evaluationForm.get('tspContactPhone').hasError('required')">
                                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                </svg>Telephone is required
                            </div>
                        </div>
                    </div>
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                        <label for="carrier_contact_telephone_ext" class="usa-label">Extension</label>
                        <input type="text" id="carrier_contact_telephone_ext" class="maxw-full usa-input" [maxlength]="5" appNumbersOnly [readonly]='isReadOnly' formControlName="tspContactPhoneExt">
                    </div>
                </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <label for="carrier_contact_email" class="usa-label">Email
                    <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
                </label>
                <input type="text" id="carrier_contact_email" class="maxw-full usa-input" formControlName="tspContactEmail" [maxlength]="254" [readonly]='isReadOnly'>
                <div *ngIf="isFormControlInValid('tspContactEmail')" class="define-text-secondary">
                    <div *ngIf="evaluationForm.get('tspContactEmail').hasError('email')">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                        </svg> Enter a valid email
                    </div>
                    <div *ngIf="evaluationForm.get('tspContactEmail').hasError('required')">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                        </svg> Email is required
                    </div>
                </div>
            </div>
        </div>

        <div class="grid-row grid-gap-1 padding-top-4" formGroupName="origin">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <h5><strong>Old Duty Station</strong></h5>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <label for="origin_country" class="usa-label">Country
                    <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
                </label>
                <select id="origin_country" class="usa-select maxw-full" formControlName="country" [attr.disabled]="isReadOnly || null" (change)="selectACountry($event)">
                    <option [ngValue]="null">..Select a Country..</option>
                    <option [ngValue]="origCountry" *ngFor="let origCountry of allCountriesList$ | async">
                        {{origCountry.stateCountryName }}
                    </option>
                </select>
                <div class="define-text-secondary" *ngIf="isFormControlInValid('origin.country')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>Old Duty Station Country is required
                </div>
            </div>

            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-9 desktop:grid-col-9" *ngIf="this.evaluationForm.get('origin.usaLocation')" formGroupName="usaLocation">
                <div class="grid-row grid-gap-1">
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                        <ng-template #customItemTemplate let-model="item">{{ model.cityName }}, {{ model.stateAbbrev }} {{ model.zipCode }}
                        </ng-template>
                        <label for="OriginSearchString" class="usa-label">Search Old Duty Station:
                            <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
                        </label>
                        <input id="OriginSearchString" class="maxw-full usa-input" formControlName="searchString" [typeaheadAsync]="true" [readonly]='isReadOnly' [typeahead]="dataSourceOriginSearchResults$" typeaheadOptionField="cityName" [typeaheadItemTemplate]="customItemTemplate"
                            (typeaheadOnSelect)="typeaheadOriginOnSelect($event)" [typeaheadOptionsInScrollableView]="10" [typeaheadOptionsLimit]="100" [typeaheadWaitMs]="1000" [typeaheadScrollable]="true" placeholder="Type a location or zip" />
                    </div>
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                        <label for="origin_city_name" class="usa-label">City</label>
                        <input type="text" readonly id="origin_city_name" class="maxw-full usa-input" formControlName="cityName" />
                    </div>
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                        <div class="grid-row grid-gap-1">
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
                                <label for="origin_state" class="usa-label">State</label>
                                <input type="text" readonly id="origin_state" class="maxw-full usa-input" formControlName="state" />
                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                <label for="origin_zip" class="usa-label">Zip Code</label>
                                <input type="text" readonly id="origin_zip" class="maxw-full usa-input" formControlName="zip" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3"
            *ngIf="this.evaluationForm.get('origin.canadaLocation')" formGroupName="canadaLocation">
                <label for="origin_Province" class="usa-label">Province
                    <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
                </label>
                <select id="origin_Province" class="usa-select maxw-full" formControlName="province" [attr.disabled]="isReadOnly || null">
                    <option [ngValue]="null">..Select a Province..</option>
                    <option [ngValue]="province" *ngFor="let province of provincesList$ | async">
                        {{province.stateCountryName}}</option>
                </select>
                <div class="define-text-secondary" *ngIf="isFormControlInValid('origin.canadaLocation.province')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>Old Duty Station Province is required
                </div>
            </div>
        </div>

        <div class="grid-row grid-gap-1 padding-top-4" formGroupName="destination">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <h5><strong>New Duty Station</strong></h5>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">

                <label class="usa-label" for="destination_country">Country <abbr title="required"
                        class="usa-hint usa-hint--required">*</abbr></label>

                <select id="destination_country" class="maxw-full usa-select" formControlName="country" [attr.disabled]="isReadOnly || null" (change)="selectACountry($event)">
                    <option [ngValue]="null">..Select a Country..</option>
                    <option [ngValue]="country" *ngFor="let country of allCountriesList$ | async">{{
                        country.stateCountryName }}
                    </option>
                </select>
                <div class="define-text-secondary" *ngIf="isFormControlInValid('destination.country')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>New Duty Station Country is required
                </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-9 desktop:grid-col-9" *ngIf="this.evaluationForm.get('destination.usaLocation')" formGroupName="usaLocation">
                <div class="grid-row grid-gap-1">
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                        <ng-template #customItemTemplate let-model="item">{{ model.cityName }}, {{ model.stateAbbrev }} {{ model.zipCode }}
                        </ng-template>
                        <label class="usa-label" for="DestinationSearchString">Search New Duty Station:
                            <abbr title="required"
                        class="usa-hint usa-hint--required">*</abbr>
                        </label>
                        <input id="DestinationSearchString" class="usa-input maxw-full" formControlName="searchString" [readonly]='isReadOnly' [typeaheadAsync]="true" [typeahead]="dataSourceDestinationSearchResults$" typeaheadOptionField="cityName" [typeaheadItemTemplate]="customItemTemplate"
                            (typeaheadOnSelect)="typeaheadDestinationOnSelect($event)" [typeaheadOptionsInScrollableView]="10" [typeaheadOptionsLimit]="100" [typeaheadWaitMs]="1000" [typeaheadScrollable]="true" placeholder="Type a location or zip" />
                    </div>
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                        <label for="destination_city_name" class="usa-label">City</label>
                        <input type="text" readonly id="destination_city_name" class="maxw-full usa-input" formControlName="cityName" />
                    </div>
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                        <div class="grid-row grid-gap-1">
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
                                <label for="destination_state" class="usa-label">State</label>
                                <input type="text" readonly id="destination_state" class="maxw-full usa-input" formControlName="state" />
                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                <label for="destinationZip" class="usa-label">Zip Code</label>
                                <input type="text" readonly id="destinationZip" class="maxw-full usa-input" formControlName="zip" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf="this.evaluationForm.get('destination.canadaLocation')" formGroupName="canadaLocation">
                <label for="dest_Province" class="usa-label">Province
                    <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
                </label>
                <select id="dest_Province" class="usa-select maxw-full" formControlName="province" [attr.disabled]="isReadOnly || null">
                    <option [ngValue]="null">..Select a Province..</option>
                    <option [ngValue]="province" *ngFor="let province of provincesList$ | async">{{
                        province.stateCountryName }}
                    </option>
                </select>
                <div class="define-text-secondary" *ngIf="isFormControlInValid('destination.canadaLocation.province')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>New Duty Station Province is required
                </div>
            </div>
        </div>

        <div class="grid-row grid-gap-1 padding-top-4">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <h5><strong>Shipment Information</strong></h5>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <ng-template #customItemTemplate let-model="item">{{ model }}
                </ng-template>
                <label for="ScacSearchString" class="usa-label">SCAC:
                    <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
                </label>
                <input class="usa-input maxw-full" type="text" placeholder="Type a SCAC" [readonly]='isReadOnly' (focusout)="validateScac()" id="ScacSearchString" formControlName='scac' [typeahead]="scacCodeList" [typeaheadMinLength]="1" (typeaheadOnSelect)="typeaheadScacOnSelect($event)"
                    [typeaheadOptionsLimit]="10" [maxlength]="4">
                <div class="define-text-secondary" *ngIf="isFormControlInValid('scac')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>SCAC is required
                </div>
                <div class="define-text-secondary" *ngIf="invalidScac">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>Please enter a valid SCAC
                </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <label for="federal_agency_id" class="usa-label">Federal Agency ID
                    <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
                </label>
                <input type="text" id="federal_agency_id" class="usa-input maxw-full" formControlName="faicCode" [maxlength]="10" [readonly]='isReadOnly'>
                <div class="define-text-secondary" *ngIf="isFormControlInValid('faicCode')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>Federal Agency ID is required
                </div>
                <div class="define-text-secondary" *ngIf="evaluationForm.get('faicCode').hasError('minlength')">
                  <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                  </svg>FAIC Code must be 10 characters long
                </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <label for="federal_agency_id" class="usa-label">Agency Location ID
                    <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
                </label>
                <input type="text" id="organizationId" class="maxw-full usa-input" formControlName="organizationId" [maxlength]="10" appNumbersOnly [readonly]='isReadOnly'>
                <div class="define-text-secondary" *ngIf="isFormControlInValid('organizationId')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>Agency Location ID is required
                </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <div class="grid-row grid-gap-1">
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                        <label for="pick_up_date" class="usa-label">Pick Up Date
                            <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
                        </label>
                        <input type="text" [attr.disabled]="isReadOnly || null" id="pick_up_date" class="usa-input maxw-full" [maxDate]="maxDate" formControlName="pickupDate" [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}" bsDatepicker>
                        <div class="define-text-secondary" *ngIf="isFormControlInValid('pickupDate')">
                            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                            </svg>Pick up date is required
                        </div>
                    </div>
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                        <label for="delivery_date" class="usa-label">Delivery Date
                            <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
                        </label>
                        <input type="text" [attr.disabled]="isReadOnly || null" id="delivery_date" class="maxw-full usa-input" [maxDate]="maxDate" formControlName="deliveryDate"  (bsValueChange)="selectACountry($event)" [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}" bsDatepicker>
                        <div class="define-text-secondary" *ngIf="isFormControlInValid('deliveryDate')">
                            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                            </svg>Delivery date is required
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <label for="bol_number" class="usa-label">BOL Number
                    <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
                </label>
                <input type="text" id="bol_number" class="usa-input maxw-full" formControlName="bolNumber" [readonly]='isReadOnly' [maxlength]="20">
                <div *ngIf="isFormControlInValid('bolNumber')" class="define-text-secondary">
                    <div *ngIf="evaluationForm.get('bolNumber').hasError('required')">

                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                        </svg> BOL number is required
                    </div>
                    <div *ngIf="evaluationForm.get('bolNumber').hasError('pattern')">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                        </svg> BOL number is invalid
                    </div>
                </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <label for="bol_type" class="usa-label">BOL Type
                    <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
                </label>
                <select id="bol_type" formControlName="bolType" class="maxw-full usa-select" title="bolType" name="bolType" [attr.disabled]="isReadOnly || null">
                    <option [ngValue]='null' selected disabled>Choose...</option>
                    <option *ngFor='let bol of bolType' [ngValue]="bol.value">{{bol.label}}</option>
                </select>
                <div class="define-text-secondary" *ngIf="isFormControlInValid('bolType')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>BOL type is required
                </div>
            </div>
            <!-- <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <label for="emp_id" class="usa-label"> Employee Unique Identifier
                    <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
                </label>
                <input type="text" id="emp_id" class="maxw-full usa-input" formControlName="uniqueEmployeeIdentifier" [readonly]='isReadOnly' [maxlength]="25">
                <div *ngIf="isFormControlInValid('uniqueEmployeeIdentifier')">
                    <div *ngIf="evaluationForm.get('uniqueEmployeeIdentifier').hasError('required')">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                        </svg>Employee Unique Identifier is required
                    </div>
                    <div *ngIf="evaluationForm.get('uniqueEmployeeIdentifier').hasError('pattern')" class="define-text-secondary">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                        </svg>Employee Unique Identifier is invalid
                    </div>
                </div>
            </div> -->

        </div>

        <div class="grid-row grid-gap-1 padding-top-2" *ngIf="hideInitiateSurveyButtons">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <ul class="usa-button-group">
                    <li class="usa-button-group__item">
                        <button type="button" class="usa-button" [disabled]="evaluationForm.invalid" (click)="initiateSurvey(this.evaluationForm)">
                            Initiate Survey
                        </button>
                    </li>
                    <li class="usa-button-group__item">
                        <button type="button" class="usa-button usa-button--secondary" (click)="resetEvaluationForm()">
                            Reset
                        </button>
                    </li>
                    <li class="usa-button-group__item">
                        <button type="button" class="usa-button usa-button--outline" (click)="backToSurvey()">
                            Back
                        </button>
                    </li>
                </ul>
            </div>
        </div>

    </form>
    <form [formGroup]="ratingForm" *ngIf="showRatingForm">
        <div class="grid-row grid-gap-1 padding-top-4" *ngIf="this.displayNewQuestion===true">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <p class="define-text-secondary" [innerHTML]="surveyMessage"></p>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <h5>With 1 Star being very Unsatisfied and 5 Stars being Very Satisfied, how would you rate the performance of the Transportation Service Provider (TSP) that handled your shipment?</h5>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="quality_packing" class="usa-label"><strong>Quality of Packing</strong></label>
                <rating formControlName="qualityOfPacking" [max]="max" id="quality_packing" class="rating" [readonly]='isRatingReadOnly'></rating>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="damage_items" class="usa-label"><strong>Damage to Items</strong></label>
                <rating formControlName="damageToItems" [max]="max" id="damage_items" class="rating" [readonly]='isRatingReadOnly'></rating>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">

                <label for="personal_courtesy" class="usa-label"><strong>Personal Courtesy of Workers</strong></label>
                <rating formControlName="courtesyWorkers" [max]="max" id="personal_courtesy" class="rating" [readonly]='isRatingReadOnly'></rating>

            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="delivery_pickup" class="usa-label"><strong>Delivery/Pickup within Scheduled
                            Timeframe</strong></label>
                <rating formControlName="delivPickupOnTime" [max]="max" id="delivery_pickup" class="rating" [readonly]='isRatingReadOnly'></rating>

            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="clear_Communication" class="usa-label"><strong>Clear Communication of Service
                            Provided</strong></label>
                <rating formControlName="clearCommunication" [max]="max" id="clear_Communication" class="rating" [readonly]='isRatingReadOnly'></rating>

            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="resolving_problems" class="usa-label"><strong>Responsive in Resolving
                            Problems</strong></label>
                <rating formControlName="responsiveInProblems" [max]="max" id="resolving_problems" class="rating" [readonly]='isRatingReadOnly'></rating>

            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="quality_Service" class="usa-label"><strong>Overall Quality of Service</strong></label>
                <rating formControlName="overallQualityService" [max]="max" id="quality_Service" class="rating" [readonly]='isRatingReadOnly'></rating>

            </div>

            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="additionalComments" class="usa-label maxw-full"><strong>Additional Comments: (Max 1000
                        characters)</strong></label>
                <textarea class="maxw-full usa-textarea" rows="5" id="additionalComments" [maxLength]="1000" formControlName="commentsRemarks" [readonly]='isRatingReadOnly'></textarea>
            </div>
        </div>

        <div class="grid-row grid-gap-1 padding-top-4" *ngIf="this.displayNewQuestion===false">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <p class="define-text-secondary" [innerHTML]="surveyMessage"></p>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <h5>With 1 Star being very Unsatisfied and 5 Stars being Very Satisfied, how would you rate the performance of the Transportation Service Provider (TSP) that handled your shipment?</h5>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="quality_packing" class="usa-label maxw-full"><strong>Quality of Packing/Damage to Items (no/little damage = 5 stars)</strong></label>
                <rating formControlName="qualityOfPacking" [max]="max" id="quality_packing" class="rating" [readonly]='isRatingReadOnly'></rating>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="personal_courtesy" class="usa-label maxw-full"><strong>Personal Courtesy of Workers</strong></label>
                <rating formControlName="courtesyWorkers" [max]="max" id="personal_courtesy" class="rating" [readonly]='isRatingReadOnly'></rating>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="delivery_pickup" class="usa-label maxw-full"><strong>Delivery/Pickup within Scheduled
                            Timeframe</strong></label>
                <rating formControlName="delivPickupOnTime" [max]="max" id="delivery_pickup" class="rating" [readonly]='isRatingReadOnly'></rating>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="clear_Communication" class="usa-label maxw-full"><strong>Clear Communication of Service Provided</strong></label>
                <rating formControlName="clearCommunication" [max]="max" id="clear_Communication" class="rating" [readonly]='isRatingReadOnly'></rating>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="resolving_problems" class="usa-label maxw-full"><strong>Responsive in Resolving
                            Problems</strong></label>
                <rating formControlName="responsiveInProblems" [max]="max" id="resolving_problems" class="rating" [readonly]='isRatingReadOnly'></rating>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="damage_items" class="usa-label maxw-full"><strong>Would You Recommend this Transportation Service Provider (TSP) to Others  (Yes = 5 stars)</strong></label>
                <rating formControlName="damageToItems" [max]="max" id="damage_items" class="rating" [readonly]='isRatingReadOnly'></rating>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="quality_Service" class="usa-label maxw-full"><strong>Overall Quality of Service</strong></label>
                <rating formControlName="overallQualityService" [max]="max" id="quality_Service" class="rating" [readonly]='isRatingReadOnly'></rating>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="additionalComments" class="usa-label maxw-full"><strong>Additional Comments: (Max 1000
                        characters)</strong></label>
                <textarea class="maxw-full usa-textarea" rows="5" id="additionalComments" [maxLength]="1000" formControlName="commentsRemarks" [readonly]='isRatingReadOnly'></textarea>
            </div>
        </div>
        <div class="grid-row padding-top-4" *ngIf="!disableForm">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <ul class="usa-button-group">
                    <li class="usa-button-group__item">
                        <button type="button" class="usa-button" [disabled]="ratingForm.invalid" (click)="submitSurvey()">
                            Submit Response
                        </button>
                    </li>
                    <li class="usa-button-group__item">
                        <button type="button" class="usa-button usa-button--secondary" (click)="resetRatingForm()">
                            Reset
                        </button>
                    </li>
                    <li class="usa-button-group__item">
                        <button type="button" class="usa-button usa-button--outline" (click)="backToSurvey()">
                            Back
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    </form>

    <form [formGroup]="amcForm" *ngIf="showAmcForm">
        <div class="grid-row grid-gap-1">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <h5>Comments</h5>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <input class="usa-checkbox__input" type="checkbox" formControlName="amcModificationRequest" id="amcModificationRequest">
                <label class="usa-checkbox__label" for="amcModificationRequest">Modification Request</label>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="amcModificationComments" class="usa-label">Modification Comments</label>
                <textarea class="usa-textarea maxw-full" rows="5" [maxLength]="500" id="amcModificationComments" formControlName="amcModificationComments"></textarea>
            </div>
        </div>
        <div class="grid-row padding-top-4" *ngIf="!showAmcButtons">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <ul class="usa-button-group">
                    <li class="usa-button-group__item">
                        <button type="button" class="usa-button" [disabled]="amcForm.invalid" (click)="submitAmcResponse()">
                            Submit Request
                        </button>
                    </li>
                    <li class="usa-button-group__item">
                        <button type="button" class="usa-button usa-button--secondary" (click)="resetAmcForm()">
                            Reset
                        </button>
                    </li>
                    <li class="usa-button-group__item">
                        <button type="button" class="usa-button usa-button--outline" (click)="backToSurvey()">
                            Back
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    </form>

    <form [formGroup]="adminForm" *ngIf="adminModeButtons">
        <div class="grid-row">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label" for="adminComments">Admin Comments <abbr title="required"
                    class="usa-hint usa-hint--required">*</abbr></label>
                <textarea class="maxw-full usa-textarea" rows="5" id="adminComments" [maxLength]="500" formControlName="adminComments"></textarea>
            </div>

        </div>
        <div class="grid-row padding-top-4">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <ul class="usa-button-group">
                    <li class="usa-button-group__item">
                        <button type="button" class="usa-button" (click)="resetRatingResponse()">Reset
                            Responses
                        </button>
                    </li>
                    <li class="usa-button-group__item">
                        <button type="button" class="usa-button" [disabled]="adminForm.invalid" (click)="modifySurvey()">Modify Survey
                        </button>
                    </li>
                    <li class="usa-button-group__item">
                        <button type="button" class="usa-button usa-button--secondary" (click)="deleteSurvey()">Delete
                            Survey</button>
                    </li>
                    <li class="usa-button-group__item">
                        <button type="button" class="usa-button" (click)="showModificationHistory(createModal)">Modification History</button>
                    </li>
                    <li class="usa-button-group__item" *ngIf="showNotifyEmployeeButton">
                        <button type="button" class="usa-button" (click)="notifyEmployee()">Send Emp. Notification
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    </form>
</div>

<div bsModal #createModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-modification-history" [config]="{backdrop: 'static'}">
    <div class="usa-modal usa-modal--lg display-flex" id="example-modal-2" aria-labelledby="modal-2-heading" aria-describedby="modal-2-description">
        <div class="usa-modal__content">
            <div class="usa-modal__main padding-y-0 define-width">
                <h2 class="usa-modal__heading pin-center" id="modal-2-heading">
                    Modification History
                </h2>
                <div class="usa-prose">
                    <div class="grid-row">
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                            <ag-grid-angular class="ag-theme-alpine" [rowData]="rowData" [domLayout]="domLayout" [pagination]="true" [paginationPageSize]="paginationPageSize" [columnDefs]="columnDefs">
                            </ag-grid-angular>
                        </div>
                    </div>
                </div>
            </div>
            <button class="usa-button usa-modal__close" aria-label="Close this window" data-close-modal (click)="createModal.hide()">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#close"></use>
                </svg>
            </button>
        </div>
    </div>
</div>
